import React, { Component } from 'react';

export default class extends Component {
	render() {
		return (
			<div id="a">
				<div id="b" style={{
					width: '500px',
					height: '1000px',
					float: 'left',
					backgroundColor: 'yellow'
				}}>
				</div>
			</div>
		);
	}
}
